import React, { useState, useEffect } from "react";
import cardImg from "../assets/card-img.jpg"; // Replace with your card image
import slide0 from "../assets/slide0.jpg";
import slide1 from "../assets/slide1.jpg";
import slide2 from "../assets/slide2.jpg";
import slide3 from "../assets/slide3.jpg";

const sliderImages = [slide0, slide1, slide2, slide3];

const containerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",

  overflow: "hidden",
};

const sliderStyle = {
  width: "100vw", // 80% of viewport width
  height: "70vh", // 80% of viewport height
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
  background: "#fff", // optional, for better contrast
  borderRadius: "1px", // optional, for rounded corners
  boxShadow: "0 2px 16px rgba(0,0,0,0.07)", // optional
};

const sliderImgStyle = {
  width: "100%", // Fill the slider area
  height: "100%",
  objectFit: "cover", // Keep aspect ratio, crop if needed
};

const cardStyle = {
  width: "340px",
  background: "#fff",
  borderRadius: "14px",
  boxShadow: "0 4px 16px rgba(0,0,0,0.10)",
  padding: "1.5rem",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const cardImgStyle = {
  width: "100%",
  height: "160px",
  objectFit: "cover",
  borderRadius: "10px",
  marginBottom: "1rem",
};

const titleStyle = {
  fontSize: "1.4rem",
  fontWeight: "600",
  margin: "0.5rem 0",
  color: "#1a237e",
};

const descStyle = {
  fontSize: "1rem",
  color: "#222",
  marginBottom: "1rem",
  textAlign: "center",
};

function Home() {
  const [current, setCurrent] = useState(0);

  // Automatically advance the slider every 2.5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % sliderImages.length);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={containerStyle}>
      {/* Slider Left Side */}
      <div>
        <div style={sliderStyle}>
          <img
            src={sliderImages[current]}
            alt={`Slide ${current + 1}`}
            style={sliderImgStyle}
          />
        </div>
        <div style={{ textAlign: "center", color: "#555" }}>
          {/* Optional: Add slider dots */}
          {sliderImages.map((_, idx) => (
            <span
              key={idx}
              style={{
                display: "inline-block",
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                background: idx === current ? "#1a237e" : "#ccc",
                margin: "0 4px",
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Home;
